import AddressItem from "../Data/AddressItem";
export default class AddressListController {
    constructor(parentContainer) {
        this.items = new Array();
        this.parentContainer = parentContainer;
        const elements = this.parentContainer.querySelectorAll('.address-item');
        for (let i = 0; i < elements.length; i++) {
            const element = elements[i];
            const item = new AddressItem(element);
            this.items.push(item);
        }
    }
}
